import { render } from "./SingleUserDisplay.vue?vue&type=template&id=1a23e071&scoped=true"
import script from "./SingleUserDisplay.vue?vue&type=script&lang=js"
export * from "./SingleUserDisplay.vue?vue&type=script&lang=js"

import "./SingleUserDisplay.vue?vue&type=style&index=0&id=1a23e071&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a23e071"]])

export default __exports__